module.exports = __webpack_public_path__ + "img/media (21).aa57696b.png";